import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import '../src/assets/scss/element-variables.scss';
import VueLazyload from "vue-lazyload";

import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import axios from "axios";
import * as Common from '../src/utils/common.js'
// import { Message } from 'element-ui'



Vue.use(ElementUI)
  .use(VideoPlayer)
  // .use(Message)
  .use(VueLazyload, {
    //完全显示的时候加载
    preLoad: 1,
    //失败时显示的图片
    error: require("./assets/newoeimg/error.png"),
    //加载时显示的GIF图
    loading: require("./assets/newoeimg/loading.gif"),
    //尝试加载几次
    attempt: 1
  });

  Vue.prototype.Common=Common

  router.afterEach((to, from, next) => {
  //跳轉頁面回到頂部
  window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title == undefined?'默认标题':to.meta.title
    if (to.meta.requireAuth) {
        let token = Cookies.get('access_token');
        let anonymous = Cookies.get('user_name');
        if (token) {

                next({
                    path: '/login',
                    query: {
                        redirect: to.fullPath
                    }
                })

        }
    }
    next();
})

Vue.config.productionTip = false;


// Vue.prototype.$axios = axios;
// axios.defaults.baseURL = process.env.BASE_API;
// console.log('process.env.BASE_API',process.env.BASE_API);

// if (module.hot) {
//   module.hot.accept();
// }
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js